
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns0dce1a025a54b3fed4038ba500923231en_US from './en-US.yaml'
            i18n.addResourceBundle('en-US', '0dce1a025a54b3fed4038ba500923231', flattenObject(ns0dce1a025a54b3fed4038ba500923231en_US), true, true);
        
            import ns0dce1a025a54b3fed4038ba500923231en from './en.yaml'
            i18n.addResourceBundle('en', '0dce1a025a54b3fed4038ba500923231', flattenObject(ns0dce1a025a54b3fed4038ba500923231en), true, true);
        
        export default '0dce1a025a54b3fed4038ba500923231';
    